<template>
  <div>
    <div class="tw-relative" style="height: 315px;" v-if="!loaded">
      <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <BaseInfinityLoading class="tw-w-20" />
      </div>
    </div>
    <iframe @load="loaded = true"
            v-if="url"
            :width="loaded ? '100%' : '0'"
            :height="loaded ? '315' : '0'"
            class="tw-rounded"
            :src="fullUrl"
            title="YouTube video player"
            frameborder="0"
            :allow="allow"
            allowfullscreen>
    </iframe>
  </div>
</template>
<script>
import BaseInfinityLoading from "./base-infinity-loading";
export default {
  components: { BaseInfinityLoading },
  props: {
    url: {
      type: String,
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    fullUrl() {
      return `${this.url}${this.autoplay ? '?autoplay=1' : ''}`
    },
    allow() {
      return [
        'accelerometer',
        'clipboard-write',
        'encrypted-media',
        'gyroscope',
        'picture-in-picture',
        this.autoplay && 'autoplay',
      ].filter(Boolean)
      .join('; ')
    }
  }
}
</script>
